export default function stripeHKPhone(phoneNum: string) {
  let stripedPhone = phoneNum.replace(/([\s])/g, '');
  if (stripedPhone[0] === '+') { stripedPhone = stripedPhone.slice(1)};
  if (stripedPhone.slice(0, 3) === '852') { stripedPhone = stripedPhone.slice(3)}
  return stripedPhone
}
